// @core/api/endpoints/platform/get_registered_platform.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformRegistryEntryResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get registered platform
 * Retrieves details about a specific platform from the discovery registry.
 */
export async function GetRegisteredPlatform(
  registry_platform_id: string,
  options?: RequestOptions
): Promise<PlatformRegistryEntryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/registry/platforms/:registry_platform_id`;
  requestPath = requestPath.replace(':registry_platform_id', encodeURIComponent(registry_platform_id));
  const requestOptions = options;
  return client.get<PlatformRegistryEntryResponse>(requestPath, { ...requestOptions });
}
